"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Image = _interopRequireDefault(require("../../Image"));

var _Share = _interopRequireDefault(require("../../Share"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; //todo 待删除


/*
 * params:
 * show 的问题需要和重构同学沟通解决
 * isAutoScroll: 是否自动滚动
 * isSelected: 是否选中状态
 * onSetAutoActive: 自动选中下一个banner
 * onClick: 点击选中banner
 * 效果:
 *	1、当展示一个banner的时候，开始进行计数， 进度条同步显示进度， 当进度5s以后，切换下一个banner。
    2、当用户点击 banner的process以后，不再进行计数， 固定在选定的banner上
 */
function BannerItem(props) {
  var _a = props || {},
      isAutoScroll = _a.isAutoScroll,
      isSelected = _a.isSelected,
      onSetAutoActive = _a.onSetAutoActive,
      _b = _a.time,
      time = _b === void 0 ? 0 : _b,
      onClick = _a.onClick,
      activeNo = _a.activeNo;

  var _c = (0, _react.useState)(0),
      timeWidth = _c[0],
      setTimeWidth = _c[1];

  (0, _react.useEffect)(function () {
    if (!isAutoScroll || !isSelected) {
      setTimeWidth(0);
      return;
    }

    var timer = setTimeout(function () {
      if (timeWidth + 1 >= 100) {
        onSetAutoActive();
        setTimeWidth(0);
      } else {
        setTimeWidth(timeWidth + 1);
      }
    }, time * 10 || 20);
    return function () {
      clearTimeout(timer);
    };
  }, [timeWidth, activeNo]);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _classnames["default"])({
      'rno-2-hero-tab-selected': !isAutoScroll && isSelected
    }),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("a", null, /*#__PURE__*/_react["default"].createElement("i", null, isAutoScroll && isSelected && /*#__PURE__*/_react["default"].createElement("b", {
    style: {
      width: timeWidth + "%"
    }
  }))));
}

var CarouseComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      source = props.source,
      time = props.time,
      imageSrc = props.imageSrc,
      shareList = props.shareList,
      _a = props.imageLocation,
      imageLocation = _a === void 0 ? false : _a,
      className = props.className,
      onClick = props.onClick,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "time", "imageSrc", "shareList", "imageLocation", "className", "onClick"]);

  var bannerNum = imageSrc.length;

  var _b = (0, _react.useState)(0),
      activeNo = _b[0],
      setActiveNo = _b[1];

  var _c = (0, _react.useState)(true),
      isAutoScroll = _c[0],
      setIsAutoScroll = _c[1];

  var bannerRef = (0, _react.useRef)(null);

  var switchFunc = function switchFunc(index) {
    var getIndex = 0; // @ts-ignore

    bannerRef.current.childNodes.forEach(function (item, i) {
      getIndex = (index + 1) % bannerNum === imageSrc.length ? 0 : (index + 1) % bannerNum;

      if (i === getIndex) {
        item.style = 'opacity: 1; transition: all 0.8s ease 0s;';
      } else {
        item.style = 'opacity: 0; z-index: -1;';
      }
    });
    setActiveNo(getIndex);
  };

  return /*#__PURE__*/_react["default"].createElement("div", __assign({}, restProps, {
    ref: ref,
    className: 'flex-default-new-dynamic-classname-container'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-new-dynamic-classname-container__children'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-new-dynamic-classname-container__children__container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'left-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'left-container-class'
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Tencent Cloud Empowers Education Sector in Thailand to Embrace Online 1232323"), /*#__PURE__*/_react["default"].createElement("article", null, "Tencent Cloud recommends the educational sector to enhance online teaching and learning models with the use of Tencent Cloud Online Education Solutions along with related Artificial Intelligence (AI) technology. The educational sector needs to be upgraded into \u201CSmart Education\u201D to ensure the continuity in response to the current COVID-19 situation. This transformation aims to increase the efficiency and capability of online education for whom integrated the technology."), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'left-container__share'
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Share["default"], {
    className: 'benefit-class-white',
    shareList: shareList
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'right-container-class'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'carouse-default-container-flex'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: bannerRef,
    className: 'carouse-default-container'
  }, imageSrc.map(function (item, index) {
    var _a = item || {},
        url = _a.url,
        href = _a.href;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])('carouse-default-container-div', {// 'carouse-default-container-div-frist'
      }),
      style: index === 0 ? {
        opacity: ' 1',
        transition: 'all 0.8s ease 0s'
      } : {
        opacity: 0,
        zIndex: -1
      }
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      pc: {
        paddingTop: ''
      },
      mo: {
        paddingTop: 185 / 330 * 100 + '%'
      },
      source: url,
      href: href
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-rno-2-hero-tab-wrap'
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'rno-2-hero-tab'
  }, imageSrc.map(function (_item, index) {
    return /*#__PURE__*/_react["default"].createElement(BannerItem, {
      isAutoScroll: isAutoScroll,
      isSelected: activeNo == index,
      activeNo: activeNo,
      time: time,
      index: index,
      onSetAutoActive: function onSetAutoActive() {
        switchFunc(index);
      },
      onClick: function onClick(ev) {
        ev.stopPropagation();
        switchFunc(index - 1); // setActiveNo(index);

        setIsAutoScroll(false);
      },
      key: "bannerScroll_" + index
    });
  }))))))));
});
CarouseComponent.displayName = 'TCICarouseComponent';
var _default = CarouseComponent;
exports["default"] = _default;